import Avatar1 from './avatar1.jpg';
import Avatar2 from './avatar2.jpg';
import Avatar3 from './avatar3.jpg';
import Avatar4 from './avatar4.jpg';
import Avatar5 from './avatar5.jpg';
import Avatar6 from './avatar6.jpg';
import Avatar7 from './avatar7.jpg';
import Avatar8 from './avatar8.jpg';
import Avatar9 from './avatar9.jpg';


export const avatarDB=[Avatar1,Avatar2,Avatar3,Avatar4,Avatar5,Avatar6,Avatar7,Avatar8,Avatar9]